import React from 'react'

const CropDashboard = () => {
  return (
    <iframe className='w-full h-full' src='https://crop-depot.pixstack.ai/' />
  )
}

export default CropDashboard